import {useHistory} from "react-router";
import React, {useEffect, useState} from "react";
import SportelliService from "../../../services/SportelliService";
import FormSportello from "./FormSportello";
import {useDispatch} from "react-redux";
import {setSearch} from "../../../actions/IndexActions";
import Enums from "../../../utils/Enums.json"

function ModificaSportello(props){

    const history = useHistory()
    const [state, setState] = useState({...props.state})
    const [showSpinner, setShowSpinner] = useState(false)
    const [rerenderAutocomplete,setRerenderAutoComplete] = useState(0)
    const dispatch = useDispatch()
    const [disabledButtonSalvaModifica,setDisabledButtonSalvaModifica] = useState(true)

    useEffect(() =>{
        setState(props.state)
        disabledSalvaModifica(props.state)
        setRerenderAutoComplete(rerenderAutocomplete+1)
    },[])

    useEffect(() =>{
        setState(props.state)
        setRerenderAutoComplete(rerenderAutocomplete+1)
    },[props])

    function disabledSalvaModifica(newState) {
        if (!newState || !newState.comune || !newState.comune.descrizione || !newState.indirizzo ||
            !newState.referente || !newState.telefono || !newState.email || !newState.latitudine || !newState.longitudine || !newState.cap) {
            return setDisabledButtonSalvaModifica(true)
        } else {
            return setDisabledButtonSalvaModifica(false)
        }
    }

    function modificaSportello() {
        setShowSpinner(true)
        let sportelloDaSalvare = {...state}
        SportelliService.modificaSportello(sportelloDaSalvare.id,sportelloDaSalvare).then(res => {
            if (res.status === 200) {
                props.getSportelli()
            } else {
                history.push({
                    pathname: "/errore"
                })
            }
            setState({comune: {}, indirizzo: "",cap: "", latitudine: "", longitudine: "", referente: "", telefono: "", email: "", orari: {},appuntamento: "",note: ""})
            setShowSpinner(false)
            window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione,"Operazione avvenuta con successo");
        }).catch(reason => {
            window.alert(Enums.TOASTERTYPE.ERROR.descrizione,"Errore durante l'esecuzione dell'operazione");
            console.log("Errore Operation PUT Sportelli: " + reason)
            setShowSpinner(false)
        })
        dispatch(setSearch(false))
    }

    function onChange(id, value) {
        let newState = {...state}
        let newId = id.replace(/[0-9]/g, '').replace("Modifica","");

        if(newId === "latitudine" || newId === "longitudine") {
            let reg = new RegExp('^[\\.0-9]*$');

            let punti = (value.match(/\./g) || []).length

            if (punti <= 1) {
                let controlloNumerico = reg.test(value)

                if (controlloNumerico) {
                    if (!value.includes(".") && value.length === 3) {
                        newState[newId] = value.substring(0, 2) + "." + value.substring(value.length - 1)
                    } else {
                        newState[newId] = value
                    }
                    setState(newState)
                }
            }
        }
        else {
            newState[newId] = value
            if (id.includes("appuntamento") && value===true){
                newState.orari={}
            }
            setState(newState)
        }

        disabledSalvaModifica(newState)
    }

    function onChangeOrari(id, value) {
        let newState = {...state}
        newState.orari[id] = value
        setState(newState)
    }

    function annullaCreazioneSportello() {
        setState({id:"", comune: "", indirizzo: "", cap: "", latitudine: "", longitudine: "",referente: "", telefono: "", email: "", orari: {},appuntamento: "",note: ""})
        setRerenderAutoComplete(rerenderAutocomplete+1)
    }

    return (
        <FormSportello modifica={true} state={state}
                       showSpinner={showSpinner} rerenderAutocomplete={rerenderAutocomplete}
                       onChange={onChange} onChangeOrari={onChangeOrari} disabledButtonSalvaModifica={disabledButtonSalvaModifica}
                       onClickAnnulla={annullaCreazioneSportello} onClickSalvaModifica={modificaSportello}
        />
    )

}
export default ModificaSportello
